import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PaymentResponse } from '../../models/interfaces';
import { LinkPagoContext } from '../../context/linkPago/LinkPagoContext';
import moment from 'moment';
import jsPDF from 'jspdf';
import logoClickLink from '../../assets/images/logo_clicklink.png';

const LinkPagoResult = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const { isLoading, loadLinkPagoSession, linkExternal, getResult3ds } = useContext(LinkPagoContext);

    const [linkToken, setLinkToken] = useState("");
    const [intentoPagar, setIntentoPagar] = useState(false);
    const [paymentResponse, setPaymentResponse] = useState<PaymentResponse | null>(null);
    const [existLink, setExistLink] = useState('');


    const getTokenFromUrl = (url: string): string | null => {
        try {
            const parsedUrl = new URL(url, window.location.origin); // agrega base si es relativo
            return parsedUrl.searchParams.get('uuid');
        } catch (e) {
            console.error('Error parsing URL:', e);
            return null;
        }
    };


    const detectCardType = (number: string) => {
        const cleaned = number.replace(/\s+/g, "");
        if (/^4/.test(cleaned)) return "Visa";
        if (/^(5[1-5]|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)/.test(cleaned)) return "Mastercard";
        if (/^3[47]/.test(cleaned)) return "Amex";
        return "";
    };

    useEffect(() => {
        // 1️⃣ Cargar el link token al iniciar la pantalla
        const lt = localStorage.getItem("linkToken");

        if (lt != null) {
            loadLinkPagoSession(lt).then((message) => {
                if (message != "success") {
                    const customPaymentResponse: PaymentResponse = {
                        payResponse: {
                            status: 'FAIL',
                            action: "",
                            creq: "",
                            threeDSSessionData: "",
                            rc: "",
                            errMsg: message,
                            rrn: "",
                            ipsRc: "",
                            card: "",
                            authCode: "",
                            orderId: "",
                            intRef: "",
                            amount: "",
                            currency: "",
                        },
                        token: ""
                    };
                    setPaymentResponse(customPaymentResponse);
                } else {
                    setLinkToken(lt);
                }
            });
        } else {
            const customPaymentResponse: PaymentResponse = {
                payResponse: {
                    status: 'FAIL',
                    action: "",
                    creq: "",
                    threeDSSessionData: "",
                    rc: "",
                    errMsg: "La respuesta ya no se encuentra disponible.",
                    rrn: "",
                    ipsRc: "",
                    card: "",
                    authCode: "",
                    orderId: "",
                    intRef: "",
                    amount: "",
                    currency: "",
                },
                token: ""
            };
            setPaymentResponse(customPaymentResponse);
        }
    }, []);

    useEffect(() => {
        // 2️⃣ Cargar el paymentResponse
        // Si viene del state (por navegación interna), lo usa.
        // Si no, lo obtiene con el clientId desde la URL.
        if (!linkToken) return; // Espera a tener linkToken cargado

        if (state?.paymentResponse) {
            setPaymentResponse(state.paymentResponse);
        } else {
            const clientId = getTokenFromUrl(window.location.href);
            if (!clientId) return;

            getResult3ds(clientId).then((response) => {
                if (response) {
                    setPaymentResponse(response);
                } else {
                    const customPaymentResponse: PaymentResponse = {
                        payResponse: {
                            status: 'FAIL',
                            action: "",
                            creq: "",
                            threeDSSessionData: "",
                            rc: "",
                            errMsg: "No se pudo obtener la respuesta del procesador.",
                            rrn: "",
                            ipsRc: "",
                            card: "",
                            authCode: "",
                            orderId: "",
                            intRef: "",
                            amount: "",
                            currency: "",
                        },
                        token: ""
                    };
                    setPaymentResponse(customPaymentResponse);
                }
            });
        }
    }, [state, linkToken]);

    /*useEffect(() => {
        // 3️⃣ Procesar resultado del pago una vez obtenido el paymentResponse
        if (intentoPagar || !paymentResponse?.payResponse) return;

        const status = paymentResponse.payResponse.status;

        if (status === "APPROVED") {
            setIntentoPagar(true);
            const idMarca = detectCardTypeId(paymentResponse.payResponse.card);
            const lt = localStorage.getItem("linkToken");

            const link = {
                status: 'APPROVED',
                orderID: paymentResponse.payResponse.orderId,
                rrn: paymentResponse.payResponse.rrn,
                intRef: paymentResponse.payResponse.intRef,
                authCode: paymentResponse.payResponse.authCode,
                Descripcion: linkExternal.descripcion,
                Currency: paymentResponse.payResponse.currency,
                idMarca: idMarca
            };

            paymentLink(link, lt);

            setTimeout(() => {
                localStorage.removeItem("linkToken");
            }, 10000);

        } else if (status === "FAIL") {
            setIntentoPagar(true);
        }
    }, [paymentResponse, linkExternal, intentoPagar]);*/


    const handleDownloadPDF = async () => {
        const original = document.getElementById("comprobante-pago");
        if (!original) return;

        // Clonar contenido para no afectar layout
        const clone = original.cloneNode(true) as HTMLElement;

        // Hacerlo invisible pero renderizable
        clone.style.position = "absolute";
        clone.style.left = "0";
        clone.style.top = "0";
        clone.style.opacity = "0.01";

        //clone.style.visibility = "hidden"; // no ocupa espacio visible
        clone.style.display = "block";      // debe estar "display: block" para renderizar
        document.body.appendChild(clone);

        // Esperar un instante para que el navegador lo pinte
        await new Promise(resolve => setTimeout(resolve, 100));

        const doc = new jsPDF({ orientation: "p", unit: "pt", format: "a4" });

        await doc.html(clone, {
            callback: function (doc) {
                doc.save("comprobante_pago.pdf");
                document.body.removeChild(clone); // limpiar
            },
            margin: [20, 20, 20, 20],
            html2canvas: {
                scale: 1.2,
                useCORS: true,
                backgroundColor: "#ffffff",
            },
        });
    };


    if (!paymentResponse?.payResponse) {
        return <div style={{ textAlign: 'center', marginTop: '5%' }}>Cargando...</div>;
    }

    const status = paymentResponse.payResponse.status;

    return (
        <div>
            <div>
                {status === "FAIL" ? (
                    <div className="d-flex justify-content-center align-items-start min-vh-100 bg-light pt-5">
                        <div className="card shadow-lg border-0 rounded-4 text-center" style={{ maxWidth: '480px' }}>
                            <div className="card-body p-4">
                                <img src={logoClickLink} alt="ClickLink by SwiftPay" className="d-block mx-auto mb-3" style={{ height: 56, maxWidth: '100%' }} />
                                <i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '3.5rem' }}></i>
                                <h4 className="mt-3 text-danger fw-bold">Error al procesar el pago</h4>
                                <p className="text-muted mb-2">
                                    No se pudo completar la transacción. Por favor, verifique los datos e intente nuevamente.
                                </p>

                                {paymentResponse.payResponse.errMsg && (
                                    <div className="alert alert-light border mt-3 text-center" role="alert">
                                        <p className="text-danger fw-semibold mb-1">{paymentResponse.payResponse.errMsg}</p>
                                        {paymentResponse.payResponse.rrn && (
                                            <p className="text-muted mb-0">
                                                <small><strong>RRN:</strong> {paymentResponse.payResponse.rrn}</small>
                                            </p>
                                        )}
                                    </div>
                                )}

                                <button className="btn btn-outline-primary mt-3" onClick={() => navigate('/linkpago/' + linkToken)}>
                                    Volver
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="d-flex justify-content-center align-items-start min-vh-100  pt-5">
                        <div className="card shadow-lg border-0 rounded-4 text-center" style={{ maxWidth: '480px' }}>
                            <div className="card-body p-4">
                                <img src={logoClickLink} alt="ClickLink by SwiftPay" className="d-block mx-auto mb-3" style={{ height: 56, maxWidth: '100%' }} />
                                <i className="bi bi-check-circle text-success" style={{ fontSize: '3.5rem' }}></i>
                                <h4 className="mt-3 text-success fw-bold">Pago realizado con éxito</h4>
                                <p className="text-muted mb-3">
                                    Tu transacción ha sido procesada correctamente. A continuación, te mostramos el detalle:
                                </p>

                                <div className="alert alert-light border mt-3 text-start" role="alert">
                                    {
                                        linkExternal != null ?

                                            <>
                                                <div className="row mb-1">
                                                    <div className="col-6 fw-bold">Comercio:</div>
                                                    <div className="col-6 text-end">{linkExternal.nombreComercio ?? ""}</div>
                                                </div>
                                                <div className="row mb-1">
                                                    <div className="col-6 fw-bold">Link de Pago:</div>
                                                    <div className="col-6 text-end">{linkExternal.referencia ?? ""}</div>
                                                </div>
                                                <div className="row ">
                                                    <div className="col-6 fw-bold">Descripción:</div>
                                                    <div className="col-6 text-end">{linkExternal.descripcion ?? ""}</div>

                                                </div>
                                                <div className="row ">
                                                    <div className="col-6 fw-bold">Cliente:</div>
                                                    <div className="col-6 text-end mb-2">{linkExternal.nombreCliente ?? ""}</div>
                                                    <hr />
                                                </div>
                                            </> : ''
                                    }

                                    {paymentResponse.payResponse.authCode && (
                                        <div className="row mb-1">
                                            <div className="col-6 fw-bold">Autorización:</div>
                                            <div className="col-6 text-end">{paymentResponse.payResponse.authCode}</div>
                                        </div>
                                    )}

                                    {paymentResponse.payResponse.rrn && (
                                        <div className="row mb-1">
                                            <div className="col-6 fw-bold">Referencia:</div>
                                            <div className="col-6 text-end">{paymentResponse.payResponse.rrn}</div>
                                        </div>
                                    )}

                                    {paymentResponse.payResponse.card && (
                                        <div className="row mb-1">
                                            <div className="col-6 fw-bold">Tarjeta:</div>
                                            <div className="col-6 text-end">
                                                {paymentResponse.payResponse.card.substring(0, 6) + "****" + paymentResponse.payResponse.card.slice(-4)}
                                            </div>
                                        </div>
                                    )}

                                    <div className="row mb-1">
                                        <div className="col-6 fw-bold">Marca:</div>
                                        <div className="col-6 text-end">
                                            {paymentResponse.payResponse.card ? detectCardType(paymentResponse.payResponse.card).toUpperCase() : "-"}
                                        </div>
                                    </div>

                                    <div className="row mb-1">
                                        <div className="col-6 fw-bold">Monto:</div>
                                        <div className="col-6 text-end">
                                            {formatMoney(paymentResponse.payResponse.amount + " " + paymentResponse.payResponse.currency)}
                                        </div>
                                    </div>

                                    <div className="row mb-1">
                                        <div className="col-6 fw-bold text-muted">Fecha:</div>
                                        <div className="col-6 text-end text-muted">{moment().format('DD/MM/YYYY HH:mm:ss')}</div>
                                    </div>
                                </div>

                                <button className="btn btn-outline-success mt-3" onClick={handleDownloadPDF}>
                                    Descargar
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {
                    status == 'APPROVED' ?
                        <div id="comprobante-pago" style={{ padding: "20px", background: "#fff", display: "none" }}>
                            <div className="d-flex justify-content-center align-items-start ">
                                <div className="card shadow-lg border-0 rounded-4 text-center" style={{ minWidth: '450px' }}>
                                    <div className="card-body p-4">


                                        <div className="alert alert-light border mt-3 text-start" role="alert">
                                            <>
                                                <img src={logoClickLink} alt="ClickLink by SwiftPay" style={{ display: 'block', height: 56, margin: '0 auto 12px' }} />
                                                <h3 style={{ color: "var(--primary-active, #003366)", marginBottom: "10px", textAlign: 'center' }}>Comprobante</h3>
                                                <div className="row mb-1">
                                                    <div className="col-6 fw-bold"></div>
                                                    <div className="col-12 text-center"> <span
                                                        style={{
                                                            background: "#d4edda",
                                                            color: "#155724",
                                                            borderRadius: "15px",
                                                            padding: "4px 10px",
                                                            fontSize: "13px",
                                                        }}
                                                    >
                                                        Pago aprobado
                                                    </span></div>
                                                </div>
                                                <div className="row mb-1 mt-3">
                                                    <div className="col-6 fw-bold">Comercio:</div>
                                                    <div className="col-6 text-end">{linkExternal.nombreComercio ?? ""}</div>
                                                </div>
                                                <div className="row mb-1">
                                                    <div className="col-6 fw-bold">Link de Pago:</div>
                                                    <div className="col-6 text-end">{linkExternal.referencia ?? ""}</div>
                                                </div>
                                                <div className="row ">
                                                    <div className="col-6 fw-bold">Descripción:</div>
                                                    <div className="col-6 text-end ">{linkExternal.descripcion ?? ""}</div>
                                                </div>
                                                <div className="row mb-1">
                                                    <div className="col-6 fw-bold">Cliente:</div>
                                                    <div className="col-6 text-end mb-2">{linkExternal.nombreCliente ?? ""}</div>
                                                    <hr />
                                                </div>
                                            </>


                                            <div className="row mb-1">
                                                <div className="col-6 fw-bold">Autorización:</div>
                                                <div className="col-6 text-end">{paymentResponse.payResponse.authCode}</div>
                                            </div>


                                            <div className="row mb-1">
                                                <div className="col-6 fw-bold">Referencia:</div>
                                                <div className="col-6 text-end">{paymentResponse.payResponse.rrn}</div>
                                            </div>


                                            <div className="row mb-1">
                                                <div className="col-6 fw-bold">Tarjeta:</div>
                                                <div className="col-6 text-end">
                                                    {paymentResponse.payResponse.card.substring(0, 6) + "****" + paymentResponse.payResponse.card.slice(-4)}
                                                </div>
                                            </div>


                                            <div className="row mb-1">
                                                <div className="col-6 fw-bold">Marca:</div>
                                                <div className="col-6 text-end">
                                                    {paymentResponse.payResponse.card ? detectCardType(paymentResponse.payResponse.card).toUpperCase() : "-"}
                                                </div>
                                            </div>

                                            <div className="row mb-1">
                                                <div className="col-6 fw-bold">Monto:</div>
                                                <div className="col-6 text-end">
                                                    {formatMoney(paymentResponse.payResponse.amount + " " + paymentResponse.payResponse.currency)}
                                                </div>
                                            </div>

                                            <div className="row mb-1">
                                                <div className="col-4 fw-bold text-muted">Fecha:</div>
                                                <div className="col-8 text-end text-muted">{moment().format('DD/MM/YYYY HH:mm:ss')}</div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>

                            <p
                                style={{
                                    textAlign: "center",
                                    color: "#6c757d",
                                    marginTop: "25px",
                                    fontSize: "13px",
                                }}
                            >
                                Gracias por su preferencia
                            </p>
                        </div> : ''
                }
            </div>
        </div>
    );
};

function formatMoney(amount: any) {
    const formatNumber = (number: number, decimalCount: number = 2, decimal: string = ",", thousands: string = ".") => {
        return number.toLocaleString(undefined, {
            minimumFractionDigits: decimalCount,
            maximumFractionDigits: decimalCount,
            useGrouping: true,
        });
    };

    return formatNumber(amount);
}

export default LinkPagoResult;
